<template>
	<div :class="['ft-disabled-tooltip-wrap', block ? 'd-block' : 'd-inline-block']">
		<slot />
		<div
			v-if="enabled"
			ref="hit"
			class="ft-disabled-tooltip-hit"
			@mouseenter="showBubble"
			@mouseleave="hideBubble"
		/>
		<Teleport to="body">
			<div
				v-if="enabled && open"
				class="tooltip b-tooltip show ft-disabled-tooltip-bubble"
				:class="'bs-tooltip-' + placement"
				role="tooltip"
				:style="bubbleStyle"
			>
				<div class="tooltip-inner">{{ title }}</div>
			</div>
		</Teleport>
	</div>
</template>

<script>
export const FULL_TRANSPARENCY_DISABLED_SWITCH_COLOR = {
	disabled: "#bfcbd9",
};

const GAP = 8;

/** @param {string} placement @param {DOMRect} rect */
function bubbleStyleForPlacement(placement, rect) {
	if (placement === "top") {
		return {
			top: `${rect.top - GAP}px`,
			left: `${rect.left + rect.width / 2}px`,
			transform: "translate(-50%, -100%)",
		};
	}
	if (placement === "bottom") {
		return {
			top: `${rect.bottom + GAP}px`,
			left: `${rect.left + rect.width / 2}px`,
			transform: "translate(-50%, 0)",
		};
	}
	if (placement === "left") {
		return {
			top: `${rect.top + rect.height / 2}px`,
			left: `${rect.left - GAP}px`,
			transform: "translate(-100%, -50%)",
		};
	}
	return {
		top: `${rect.top + rect.height / 2}px`,
		left: `${rect.right + GAP}px`,
		transform: "translate(0, -50%)",
	};
}

export default {
	name: "FullTransparencyDisabledTooltip",
	props: {
		enabled: {
			type: Boolean,
			default: false,
		},
		placement: {
			type: String,
			default: "right",
		},
		title: {
			type: String,
			default: "Disabled because Full Transparency is enabled for this publisher",
		},
		block: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			open: false,
			bubbleStyle: {},
			dismissBound: false,
		};
	},
	watch: {
		enabled(value) {
			if (!value) {
				this.hideBubble();
			}
		},
	},
	beforeUnmount() {
		this.hideBubble();
	},
	methods: {
		showBubble() {
			const el = this.$refs.hit;
			if (!(el instanceof HTMLElement)) {
				return;
			}
			this.bubbleStyle = bubbleStyleForPlacement(this.placement, el.getBoundingClientRect());
			this.open = true;
			this.bindDismiss();
		},
		hideBubble() {
			this.open = false;
			this.unbindDismiss();
		},
		bindDismiss() {
			if (this.dismissBound) {
				return;
			}
			window.addEventListener("scroll", this.hideBubble, true);
			window.addEventListener("resize", this.hideBubble);
			this.dismissBound = true;
		},
		unbindDismiss() {
			if (!this.dismissBound) {
				return;
			}
			window.removeEventListener("scroll", this.hideBubble, true);
			window.removeEventListener("resize", this.hideBubble);
			this.dismissBound = false;
		},
	},
};
</script>

<style scoped>
.ft-disabled-tooltip-wrap {
	position: relative;
}

.ft-disabled-tooltip-hit {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 5;
}
</style>

<style>
/* Teleported to body. position:fixed escapes modal overflow; z-index sits above ov-modal (2000) and msgbox (3000). */
.ft-disabled-tooltip-bubble.tooltip {
	position: fixed;
	opacity: 1;
}
</style>
